import React, { useEffect, useState } from 'react';
import api from '../services/api';

const DIAS = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];

const Configuracion: React.FC = () => {
  const [, setConfig] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [form, setForm] = useState({
    diaCorte: 15,
    nombreEmpresa: '',
    moneda: 'S/.',
    colorPrimario: '#0ea5e9',
    telefonoEmpresa: '',
    direccionEmpresa: '',
    logoUrl: '',
    metaCobro: 0,
    costoReconexion: 0,
    tasaMora: 0,
  });
  const [cobradores, setCobradores] = useState<any[]>([]);
  const [zonas, setZonas] = useState<string[]>([]);
  // zonaMatrix[cobradorId][dia 0-6] = zona|''
  const [zonaMatrix, setZonaMatrix] = useState<Record<string, Record<number, string>>>({});

  const cargar = async () => {
    setLoading(true);
    try {
      const [confRes, usrRes, cliRes] = await Promise.all([
        api.get('/configuracion'),
        api.get('/usuarios'),
        api.get('/clientes'),
      ]);
      const data = confRes.data;
      setConfig(data);
      setForm({
        diaCorte: data.diaCorte,
        nombreEmpresa: data.nombreEmpresa || '',
        moneda: data.moneda || 'S/.',
        colorPrimario: data.colorPrimario || '#0ea5e9',
        telefonoEmpresa: data.telefonoEmpresa || '',
        direccionEmpresa: data.direccionEmpresa || '',
        logoUrl: data.logoUrl || '',
        metaCobro: Number(data.metaCobro) || 0,
        costoReconexion: Number(data.costoReconexion) || 0,
        tasaMora: Number(data.tasaMora) || 0,
      });

      const cobs = (usrRes.data || []).filter((u: any) => u.rol === 'cobrador');
      setCobradores(cobs);

      const zonasUnicas: string[] = Array.from(
        new Set((cliRes.data || []).map((c: any) => c.zona).filter(Boolean))
      ).sort() as string[];
      setZonas(zonasUnicas);

      // Construir matriz desde zonasPorDia
      const zpd: any[] = data.zonasPorDia || [];
      const matrix: Record<string, Record<number, string>> = {};
      for (const cob of cobs) {
        matrix[cob.id] = {};
        for (let d = 0; d < 7; d++) matrix[cob.id][d] = '';
        for (const asig of zpd) {
          if (asig.cobradorId === cob.id && Array.isArray(asig.dias)) {
            for (const dia of asig.dias) matrix[cob.id][dia] = asig.zona || '';
          }
        }
      }
      setZonaMatrix(matrix);
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const handleLogo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setForm(f => ({ ...f, logoUrl: reader.result as string }));
    reader.readAsDataURL(file);
  };

  const setZona = (cobradorId: string, dia: number, zona: string) => {
    setZonaMatrix(prev => ({
      ...prev,
      [cobradorId]: { ...prev[cobradorId], [dia]: zona },
    }));
  };

  const matrizAZonasPorDia = () => {
    const result: { cobradorId: string; zona: string; dias: number[] }[] = [];
    for (const cobId of Object.keys(zonaMatrix)) {
      const diasPorZona: Record<string, number[]> = {};
      for (let d = 0; d < 7; d++) {
        const z = zonaMatrix[cobId][d];
        if (z) {
          if (!diasPorZona[z]) diasPorZona[z] = [];
          diasPorZona[z].push(d);
        }
      }
      for (const [zona, dias] of Object.entries(diasPorZona)) {
        result.push({ cobradorId: cobId, zona, dias });
      }
    }
    return result;
  };

  const guardar = async () => {
    setGuardando(true);
    try {
      await api.put('/configuracion', { ...form, zonasPorDia: matrizAZonasPorDia() });
      alert('Configuracion guardada');
      cargar();
    } catch { alert('Error al guardar'); }
    finally { setGuardando(false); }
  };

  if (loading) return <div style={{ color:'#64748b', textAlign:'center', padding:48 }}>Cargando...</div>;

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>Configuracion</h2>
        <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Configuracion general e imagen corporativa</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
        {/* Imagen corporativa */}
        <div style={{ background:'#1e293b', borderRadius:16, padding:24, border:'1px solid #334155' }}>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15, marginBottom:16 }}>Imagen corporativa</div>

          {/* Logo */}
          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:8 }}>Logo de la empresa</label>
            {form.logoUrl ? (
              <div style={{ marginBottom:8 }}>
                <img src={form.logoUrl} alt="logo" style={{ width:120, height:120, objectFit:'contain', borderRadius:12, border:'1px solid #334155', background:'#0f172a', padding:8 }} />
                <button onClick={() => setForm(f => ({...f, logoUrl:''}))}
                  style={{ display:'block', marginTop:6, background:'none', border:'none', color:'#ef4444', cursor:'pointer', fontSize:12 }}>
                  Quitar logo
                </button>
              </div>
            ) : (
              <div style={{ width:120, height:120, background:'#0f172a', borderRadius:12, border:'2px dashed #334155', display:'flex', alignItems:'center', justifyContent:'center', color:'#64748b', fontSize:12, textAlign:'center', marginBottom:8 }}>
                Sin logo
              </div>
            )}
            <input type="file" accept="image/*" onChange={handleLogo} style={{ color:'#94a3b8', fontSize:12 }} />
          </div>

          {/* Color primario */}
          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:8 }}>Color principal</label>
            <div style={{ display:'flex', gap:10, alignItems:'center' }}>
              <input type="color" value={form.colorPrimario} onChange={e => setForm({...form, colorPrimario: e.target.value})}
                style={{ width:48, height:48, borderRadius:8, border:'1px solid #334155', cursor:'pointer', background:'none', padding:2 }} />
              <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:13 }}>{form.colorPrimario}</div>
            </div>
            <div style={{ marginTop:10, display:'flex', gap:8, flexWrap:'wrap' }}>
              {['#0ea5e9','#22c55e','#f59e0b','#ef4444','#8b5cf6','#06b6d4','#ec4899'].map(color => (
                <div key={color} onClick={() => setForm({...form, colorPrimario: color})}
                  style={{ width:28, height:28, borderRadius:'50%', background:color, cursor:'pointer', border:`2px solid ${form.colorPrimario === color ? 'white' : 'transparent'}` }} />
              ))}
            </div>
          </div>

          {/* Preview */}
          <div style={{ background:'#0f172a', borderRadius:10, padding:14, border:'1px solid #334155' }}>
            <div style={{ color:'#64748b', fontSize:11, marginBottom:8 }}>Vista previa</div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              {form.logoUrl ? (
                <img src={form.logoUrl} alt="logo" style={{ width:40, height:40, objectFit:'contain', borderRadius:8, background:'white', padding:4 }} />
              ) : (
                <div style={{ width:40, height:40, borderRadius:8, background:form.colorPrimario, display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:800, fontSize:18 }}>A</div>
              )}
              <div>
                <div style={{ color:form.colorPrimario, fontWeight:800, fontSize:15 }}>{form.nombreEmpresa || 'Mi Empresa'}</div>
                <div style={{ color:'#64748b', fontSize:11 }}>Sistema de Agua</div>
              </div>
            </div>
          </div>
        </div>

        {/* Configuracion general */}
        <div style={{ background:'#1e293b', borderRadius:16, padding:24, border:'1px solid #334155' }}>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15, marginBottom:16 }}>Datos de la empresa</div>

          {[
            { label:'Nombre de la empresa', key:'nombreEmpresa', type:'text', placeholder:'Mi Empresa de Agua' },
            { label:'Telefono', key:'telefonoEmpresa', type:'text', placeholder:'987654321' },
            { label:'Direccion', key:'direccionEmpresa', type:'text', placeholder:'Jr. Principal 123' },
          ].map(f => (
            <div key={f.key} style={{ marginBottom:16 }}>
              <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>{f.label}</label>
              <input value={(form as any)[f.key]} onChange={e => setForm({...form, [f.key]: e.target.value})}
                type={f.type} placeholder={f.placeholder}
                style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:13, boxSizing:'border-box' as any }} />
            </div>
          ))}

          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Dia de corte mensual</label>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <input value={form.diaCorte} onChange={e => setForm({...form, diaCorte: Number(e.target.value)})}
                type="number" min="1" max="28"
                style={{ width:80, background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14 }} />
              <span style={{ color:'#64748b', fontSize:13 }}>de cada mes</span>
            </div>
          </div>

          <div style={{ marginBottom:24 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Moneda</label>
            <select value={form.moneda} onChange={e => setForm({...form, moneda: e.target.value})}
              style={{ width:'100%', background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:13 }}>
              <option value="S/.">S/. — Soles peruanos</option>
              <option value="$">$ — Dolares</option>
            </select>
          </div>

          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Meta de cobro diaria (S/.)</label>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <input value={form.metaCobro} onChange={e => setForm({...form, metaCobro: Number(e.target.value)})}
                type="number" min="0" step="0.01"
                style={{ width:120, background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14 }} />
              <span style={{ color:'#64748b', fontSize:13 }}>soles por dia (0 = sin meta)</span>
            </div>
          </div>

          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Costo de reconexion (S/.)</label>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <input value={form.costoReconexion} onChange={e => setForm({...form, costoReconexion: Number(e.target.value)})}
                type="number" min="0" step="0.01"
                style={{ width:120, background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14 }} />
              <span style={{ color:'#64748b', fontSize:13 }}>soles (0 = sin costo)</span>
            </div>
          </div>

          <div style={{ marginBottom:16 }}>
            <label style={{ color:'#94a3b8', fontSize:12, fontWeight:600, display:'block', marginBottom:6 }}>Tasa de mora mensual (%)</label>
            <div style={{ display:'flex', alignItems:'center', gap:12 }}>
              <input value={form.tasaMora} onChange={e => setForm({...form, tasaMora: Number(e.target.value)})}
                type="number" min="0" max="100" step="0.1"
                style={{ width:120, background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', color:'white', fontSize:14 }} />
              <span style={{ color:'#64748b', fontSize:13 }}>% mensual sobre deuda (0 = sin mora)</span>
            </div>
          </div>

          <div style={{ background:'#0ea5e911', border:'1px solid #0ea5e933', borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
            <div style={{ color:'#38bdf8', fontWeight:700, fontSize:13, marginBottom:4 }}>Como funciona el dia de corte</div>
            <div style={{ color:'#64748b', fontSize:12, lineHeight:1.6 }}>
              El dia {form.diaCorte} de cada mes se generan las facturas para todos los clientes activos y se envian recordatorios por WhatsApp.
            </div>
          </div>
        </div>
      </div>

      {/* Zonas por día */}
      {cobradores.length > 0 && (
        <div style={{ background:'#1e293b', borderRadius:16, padding:24, border:'1px solid #334155', marginTop:20 }}>
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15, marginBottom:4 }}>Zonas por día — Calendario del cobrador</div>
          <div style={{ color:'#64748b', fontSize:12, marginBottom:16 }}>
            Asigna qué zona cubre cada cobrador cada día. La app filtra automáticamente la lista de clientes según la zona del día.
          </div>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:600 }}>
              <thead>
                <tr>
                  <th style={{ padding:'10px 14px', color:'#64748b', fontSize:12, textAlign:'left', background:'#0f172a', borderRadius:'8px 0 0 0' }}>Cobrador</th>
                  {DIAS.map((d, i) => (
                    <th key={i} style={{ padding:'10px 10px', color: i === 0 || i === 6 ? '#f59e0b' : '#64748b', fontSize:12, textAlign:'center', background:'#0f172a' }}>{d}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cobradores.map(cob => (
                  <tr key={cob.id} style={{ borderBottom:'1px solid #334155' }}>
                    <td style={{ padding:'10px 14px', color:'#f1f5f9', fontWeight:600, fontSize:13, whiteSpace:'nowrap' }}>
                      {cob.nombre} {cob.apellido}
                    </td>
                    {Array.from({length:7}, (_, d) => (
                      <td key={d} style={{ padding:'6px', textAlign:'center' }}>
                        <select
                          value={zonaMatrix[cob.id]?.[d] ?? ''}
                          onChange={e => setZona(cob.id, d, e.target.value)}
                          style={{ background: zonaMatrix[cob.id]?.[d] ? '#0ea5e920' : '#0f172a', border:`1px solid ${zonaMatrix[cob.id]?.[d] ? '#0ea5e9' : '#334155'}`, borderRadius:6, padding:'4px 6px', color: zonaMatrix[cob.id]?.[d] ? '#38bdf8' : '#475569', fontSize:11, width:80, cursor:'pointer' }}>
                          <option value="">—</option>
                          {zonas.map(z => <option key={z} value={z}>{z}</option>)}
                        </select>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {zonas.length === 0 && (
            <div style={{ color:'#f59e0b', fontSize:12, marginTop:12, padding:'10px 14px', background:'#f59e0b11', borderRadius:8, border:'1px solid #f59e0b33' }}>
              No hay zonas definidas. Asigna una zona a los clientes desde la sección Clientes para poder configurar el calendario.
            </div>
          )}
        </div>
      )}

      <button onClick={guardar} disabled={guardando}
        style={{ marginTop:20, width:'100%', background:'#0ea5e9', border:'none', color:'white', borderRadius:10, padding:'14px', cursor:'pointer', fontWeight:700, fontSize:15, opacity: guardando ? 0.7 : 1 }}>
        {guardando ? 'Guardando...' : 'Guardar Configuracion'}
      </button>
    </div>
  );
};

export default Configuracion;
